import { State } from '../state'
import BasisTypeState from '../basistypesState'
import type { AddressActions, IGetData } from './addressState.types'
import { addressActions } from './addressState.types'
import type { BookingflowStateMachine } from '../../bookingflowstatemachine'
import { Address } from '@raskrask-dk/raskrask-utils'

const ADDRESS_STATE = 'ADDRESS'
export class AddressState extends State<AddressActions, typeof ADDRESS_STATE> {
    public readonly type = ADDRESS_STATE
    private _address: Address | undefined

    constructor(bookingflowStateMachine: BookingflowStateMachine) {
        super(bookingflowStateMachine)
    }

    private nextState(): BasisTypeState {
        const { address, customerType } = this.bookingflowStateMachine.getData()

        return new BasisTypeState(this.bookingflowStateMachine, {
            address: address as Address,
            customerType: customerType,
        })
    }

    /**
     *
     * @param action - The action that is given
     * On the addressState there are no values dependent on
     */
    public unset = (): void => {
        return
    }

    public doAction = (
        action: AddressActions
    ): BasisTypeState | AddressState => {
        switch (action.type) {
            case 'NEXT_STATE':
                this._address = action.data
                return action.isValid() ? this.nextState() : this
            default:
                throw new Error('Unhandled Exception')
        }
    }

    public getActions(): typeof addressActions {
        return addressActions.filter((action) => new action(this).isDoable())
    }

    public get address(): Address | undefined {
        return this._address
    }

    public getData(): IGetData {
        return { address: this.address }
    }
}
